const TextArea: React.FC<{
  id?: string;
  className?: string;
  name?: string;
  rows?: number;
  placeholder?: string;
  defaultValue?: string;
  value?: string;
}> = ({
  id,
  className,
  name,
  rows = 3,
  placeholder,
  defaultValue,
  value,
  ...props
}) => {
    return (
      <>
        <textarea
          className={`block outline-none w-full sm:text-sm border placeholder-gray-300 border-gray-300 
            rounded-md shadow-sm focus:ring-transparent focus:border-sprimary-500 
            ${className ? className : ''}
          `}
          id={id}
          name={name}
          rows={rows}
          placeholder={placeholder}
          defaultValue={defaultValue}
          value={value}
          {...props}
        />
      </>
    )
  }
export default TextArea